import AddRoundedIcon from '@mui/icons-material/AddRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import cn from 'classnames';
import React, { FC } from 'react';

import styles from './QuantityButton.module.sass';
import { useQuantityButton } from './useQuantityButton';

const QuantityButton: FC<{ item: any }> = ({ item }) => {
  const { checkCount, removeCount, addCount, availabilityCount } =
    useQuantityButton(item);
  return (
    <div className={styles.wrapper}>
      <button
        className={styles.remove}
        onClick={() => removeCount(item)}
        type="button"
      >
        <RemoveRoundedIcon />
      </button>

      <span className={styles.text}>{availabilityCount}</span>

      <button
        className={cn(styles.add, {
          [styles.disabled]: checkCount(item),
        })}
        disabled={checkCount(item)}
        onClick={() => addCount(item)}
        type="button"
      >
        <AddRoundedIcon />
      </button>
    </div>
  );
};

export default QuantityButton;
